var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":_vm.trigger}},[_vm._t("trigger",function(){return [_c('MIcon',{staticClass:"action-menu-icon",attrs:{"name":"print"}}),_c('span',{staticClass:"ml-1 action-menu-text"},[_vm._v(" "+_vm._s(_vm.$tc('print'))+" "+_vm._s(_vm.$tc('barcode'))+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }